import { Field } from '@web/components/atoms/Field'
import { Box } from '@web/components/atoms/Layout'
import { Textarea } from '@web/components/atoms/Textarea'
import { useState, type ChangeEvent } from 'react'

export const MESSAGE_OF_SUPPORT_MAX_LENGTH = 255
const SHOW_COUNT_WHEN_REMAINING_AT_MOST = 20

type MessageOfSupportFieldProps = {
  id?: string
  name?: string
  label?: string
  required?: boolean
  value?: string
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  bgColor?: string
  color?: string
}

const messageOfSupportCount = (length: number) => {
  const remaining = MESSAGE_OF_SUPPORT_MAX_LENGTH - length
  if (remaining > SHOW_COUNT_WHEN_REMAINING_AT_MOST) {
    return null
  }

  return `${length}/${MESSAGE_OF_SUPPORT_MAX_LENGTH}`
}

const MessageOfSupportField = ({
  id = 'comment',
  name = 'comment',
  label = 'Message of Support',
  required,
  value,
  onChange,
  bgColor,
  color,
}: MessageOfSupportFieldProps) => {
  const [uncontrolledLength, setUncontrolledLength] = useState(value?.length ?? 0)
  const length = value?.length ?? uncontrolledLength
  const count = messageOfSupportCount(length)
  const atLimit = length >= MESSAGE_OF_SUPPORT_MAX_LENGTH

  return (
    <Field
      label={label}
      htmlFor={id}
      required={required}
      w="100%"
      actionSlot={
        count ? (
          <Box ml="auto" fontSize="sm" color={atLimit ? 'ge.text.danger' : 'fg.muted'} flexShrink={0}>
            {count}
          </Box>
        ) : undefined
      }
    >
      <Textarea
        id={id}
        name={name}
        required={required}
        value={value}
        maxLength={MESSAGE_OF_SUPPORT_MAX_LENGTH}
        placeholder="Enter a message of support"
        bgColor={bgColor}
        color={color}
        onChange={(event) => {
          const nextValue = event.target.value.slice(0, MESSAGE_OF_SUPPORT_MAX_LENGTH)
          if (event.target.value !== nextValue) {
            event.target.value = nextValue
          }
          setUncontrolledLength(nextValue.length)
          onChange?.(event)
        }}
      />
    </Field>
  )
}

export default MessageOfSupportField
